import { Component } from '@theme/component';

/**
 * Simple exclusive tabs: a row of buttons toggling the panels below.
 * Buttons carry `aria-expanded`/`aria-controls`; panels use `hidden`.
 */
class CCTabs extends Component {
  /**
   * Handle a tab click: show its panel, hide the rest.
   * @param {Event} event
   */
  select(event) {
    const button = event.target instanceof Element && event.target.closest('.cc-tabs__tab');
    if (!(button instanceof HTMLElement)) return;

    for (const tab of this.querySelectorAll('.cc-tabs__tab')) {
      const panel = document.getElementById(tab.getAttribute('aria-controls') ?? '');
      const expand = tab === button;
      tab.setAttribute('aria-expanded', String(expand));
      if (panel) panel.hidden = !expand;
    }

    // Embedded review widgets mount while their panel is still hidden and size
    // themselves to a zero-width box; nudge them once the panel is visible.
    window.dispatchEvent(new Event('resize'));
  }
}

if (!customElements.get('cc-tabs')) {
  customElements.define('cc-tabs', CCTabs);
}
